export enum SessionError {
  NO_SESSION,
  JOIN_FAILURE,
}
